/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, you can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * Copyright Oxide Computer Company
 */
import { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const IpGlobal24Icon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.412 1.09a11.108 11.108 0 0 0-2.824 0c-.332.453-.671 1.049-.992 1.798C9.108 4.026 8.703 5.42 8.423 7h7.154c-.28-1.58-.685-2.974-1.173-4.112-.32-.749-.66-1.345-.992-1.798Zm2.694.702c.656 1.436 1.173 3.212 1.5 5.208h4.195a11.04 11.04 0 0 0-5.695-5.208ZM22.586 9h-4.724c.09.966.138 1.97.138 3s-.048 2.034-.138 3h4.724c.27-.954.414-1.96.414-3s-.144-2.046-.414-3Zm-.785 8h-4.195c-.327 1.995-.844 3.772-1.5 5.208A11.041 11.041 0 0 0 21.801 17Zm-8.389 5.91a11.12 11.12 0 0 1-2.824 0c-.332-.453-.671-1.049-.992-1.798-.488-1.138-.893-2.532-1.173-4.112h7.154c-.28 1.58-.685 2.974-1.173 4.112-.32.749-.66 1.345-.992 1.798Zm-5.518-.702A11.04 11.04 0 0 1 2.199 17h4.195c.327 1.995.844 3.772 1.5 5.208ZM1.414 15h4.724C6.048 14.034 6 13.03 6 12s.048-2.034.138-3H1.414C1.144 9.954 1 10.96 1 12s.144 2.046.414 3ZM2.2 7h4.195c.327-1.996.844-3.772 1.5-5.208A11.04 11.04 0 0 0 2.199 7ZM8 12c0 1.04.052 2.044.147 3h7.706c.095-.956.147-1.96.147-3s-.052-2.044-.147-3H8.147C8.052 9.956 8 10.96 8 12Z"
      fill="currentColor"
    />
  </svg>
)
export default IpGlobal24Icon
